__turbopack_context__.v({
  "icon": "style-module-scss-module__MghFaG__icon",
  "selected": "style-module-scss-module__MghFaG__selected",
  "wrapper": "style-module-scss-module__MghFaG__wrapper",
});
